import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 402 → broadcast a "pro-upsell" event so any mounted ProUpsell modal
// can pop with the right message. Throws the original error onward so caller
// .catch() still runs.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const detail = err.response.data?.detail;
      const payload = typeof detail === "object" ? detail : { code: "pro_required", message: detail || "This feature is on Shop, Cal & Meal Pro." };
      try {
        window.dispatchEvent(new CustomEvent("pro-upsell", { detail: payload }));
      } catch { /* ignore */ }
    }
    return Promise.reject(err);
  }
);
